export default __webpack_public_path__ + "static/media/Vector4.076a57b9.svg";